import type { PhieuThu, PhieuThuInput } from '@/types/schemas';
import { FormMode } from '@/types/form';

interface UsePhieuThuMutationParams {
  formMode: FormMode;
  selectedObj: PhieuThu | null | undefined;
  addItem: (data: PhieuThuInput) => Promise<PhieuThu>;
  updateItem: (uuid: string, data: PhieuThuInput) => Promise<PhieuThu>;
  deleteItem: (uuid: string) => Promise<void>;
  handleCloseForm: () => void;
  clearSelection: () => void;
  refreshData: () => Promise<void>;
}

export const usePhieuThuMutation = ({
  formMode,
  selectedObj,
  addItem,
  updateItem,
  deleteItem,
  handleCloseForm,
  clearSelection,
  refreshData
}: UsePhieuThuMutationParams) => {
  const handleSubmit = async (data: PhieuThuInput) => {
    if (formMode === 'add') {
      await addItem(data);
    } else if (formMode === 'edit' && selectedObj?.uuid) {
      await updateItem(selectedObj.uuid, data);
    }

    handleCloseForm();
    clearSelection();
    await refreshData();
  };

  return {
    handleSubmit,
    handleDelete: deleteItem
  };
};
